export default {
  SET_CASHFLOW (state, cashFlow) {
    state.cashFlow = cashFlow
  },
  REMOVE_RECORD (state, itemId) {
    const cashFlowIndex = state.cashFlow.findIndex((u) => u.id === itemId)
    state.cashFlow.splice(cashFlowIndex, 1)
  }
}
